import React from "react"
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";

import { DialogBase, Props } from "./DialogBase";
import { generateSectionIndex } from "../../utilities/ElementUtils";
import './DialogForTileSelectionComponent.css';

interface State {}

export class DialogForTileSelectionComponent extends DialogBase<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                <Dialog header={this.props.isEng ? "Tile Selection Properties for " + this.props.ele.ENUTitle : "Tile Selection Properties for " + this.props.ele.FRATitle}
                    footer={this.renderFooter()}
                    visible={this.props.dialogVisible}
                    className="ontario-dialog"
                    onHide={() => this.props.callback(false)}>
                    {this.defaultComponentFields()}
                </Dialog>
            </>
        );
        return html;
    }

    defaultComponentFields = () => {
        let htmlString = [];

        if (!this.props.ele.TileSelection) {
            this.props.ele.TileSelection = {
                apiUrl: '',
                responseKey: 'services',
                idField: 'id',
                nameField: 'name',
                autoSelectSingle: true,
                redirectUrl: ''
            };
        }

        htmlString.push(
            <div>
                {this.questionHintHtml()}

                <div className="tile-dialog-row">
                    <div className="tile-dialog-label">
                        <label htmlFor={"api_url_" + this.props.ele.Sequence}>API URL:</label>
                    </div>
                    <div className="tile-dialog-input">
                        <InputText
                            className="ontario-input"
                            id={"api_url_" + this.props.ele.Sequence}
                            placeholder="/api/v1/user/partners"
                            value={this.props.ele.TileSelection?.apiUrl || ''}
                            onChange={(e) => {
                                this.props.ele.TileSelection = {
                                    ...this.props.ele.TileSelection,
                                    apiUrl: e.target.value
                                };
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div className="tile-dialog-row">
                    <div className="tile-dialog-label">
                        <label htmlFor={"response_key_" + this.props.ele.Sequence}>Response Key:</label>
                    </div>
                    <div className="tile-dialog-input">
                        <InputText
                            className="ontario-input"
                            id={"response_key_" + this.props.ele.Sequence}
                            placeholder="services"
                            value={this.props.ele.TileSelection?.responseKey || 'services'}
                            onChange={(e) => {
                                this.props.ele.TileSelection = {
                                    ...this.props.ele.TileSelection,
                                    responseKey: e.target.value
                                };
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div className="tile-dialog-row">
                    <div className="tile-dialog-label">
                        <label htmlFor={"id_field_" + this.props.ele.Sequence}>ID Field:</label>
                    </div>
                    <div className="tile-dialog-input">
                        <InputText
                            className="ontario-input"
                            id={"id_field_" + this.props.ele.Sequence}
                            placeholder="id"
                            value={this.props.ele.TileSelection?.idField || 'id'}
                            onChange={(e) => {
                                this.props.ele.TileSelection = {
                                    ...this.props.ele.TileSelection,
                                    idField: e.target.value
                                };
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div className="tile-dialog-row">
                    <div className="tile-dialog-label">
                        <label htmlFor={"name_field_" + this.props.ele.Sequence}>Name Field:</label>
                    </div>
                    <div className="tile-dialog-input">
                        <InputText
                            className="ontario-input"
                            id={"name_field_" + this.props.ele.Sequence}
                            placeholder="name"
                            value={this.props.ele.TileSelection?.nameField || 'name'}
                            onChange={(e) => {
                                this.props.ele.TileSelection = {
                                    ...this.props.ele.TileSelection,
                                    nameField: e.target.value
                                };
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div className="tile-dialog-row">
                    <div className="tile-dialog-label">
                        <label htmlFor={"redirect_url_" + this.props.ele.Sequence}>Redirect URL:</label>
                    </div>
                    <div className="tile-dialog-input">
                        <InputText
                            className="ontario-input"
                            id={"redirect_url_" + this.props.ele.Sequence}
                            placeholder="/dashboard?serviceName={name}&serviceId={id}"
                            value={this.props.ele.TileSelection?.redirectUrl || ''}
                            onChange={(e) => {
                                this.props.ele.TileSelection = {
                                    ...this.props.ele.TileSelection,
                                    redirectUrl: e.target.value
                                };
                                this.props.callback();
                            }} />
                        <div className="tile-dialog-hint">
                            Use {'{name}'} and {'{id}'} as placeholders (external URL only)
                        </div>
                    </div>
                </div>

                <div className="tile-dialog-row">
                    <div className="tile-dialog-label">
                        <label htmlFor={"next_section_" + this.props.ele.Sequence}>Next Section:</label>
                    </div>
                    <div className="tile-dialog-input">
                        <Dropdown
                            id={"next_section_" + this.props.ele.Sequence}
                            className="ontario-input"
                            value={this.props.ele.TileSelection?.nextSection}
                            options={generateSectionIndex(this.props.ele).map(s => ({
                                label: `${s.sequence}. ${s.title}`,
                                value: s.sequence
                            }))}
                            onChange={(e) => {
                                this.props.ele.TileSelection = {
                                    ...this.props.ele.TileSelection,
                                    nextSection: e.value
                                };
                                this.props.callback();
                            }}
                            placeholder="Select section to navigate"
                            showClear
                        />
                        <div className="tile-dialog-hint">
                            Takes priority over Redirect URL
                        </div>
                    </div>
                </div>

                <div className="tile-dialog-row">
                    <div className="tile-dialog-label">
                        <label htmlFor={"auto_select_" + this.props.ele.Sequence}>Auto-select if single:</label>
                    </div>
                    <div className="tile-dialog-input">
                        <Checkbox
                            id={"auto_select_" + this.props.ele.Sequence}
                            checked={this.props.ele.TileSelection?.autoSelectSingle !== false}
                            onChange={(e) => {
                                this.props.ele.TileSelection = {
                                    ...this.props.ele.TileSelection,
                                    autoSelectSingle: e.checked
                                };
                                this.props.callback();
                            }} />
                    </div>
                </div>

                {this.tooTipHtml()}

                {this.excludeFromPayload()}

                {this.InitialVisibility()}
            </div>
        )

        return htmlString;
    }

    renderFooter = () => {
        return (
            <div className="tile-dialog-footer">
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />
            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
